var _rect, _path, _mask, _g, _ellipse, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoSimple = function SvgLogoSimple(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 40,
    viewBox: "0 0 98 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9785,
    y: 10,
    width: 18.9648,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1185 10L17.0593 0L0 10V30L17.0593 40L34.1185 30V10ZM30.0328 28.909V25.0145H20.7337V21.7563H28.6354V17.989H20.7337V14.9854H29.7025V11.0908H15.7538V28.909H30.0328Z",
    fill: "#34995C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1185 10L17.0593 0L0 10V30L17.0593 40L34.1185 30V10ZM30.0328 28.909V25.0145H20.7337V21.7563H28.6354V17.989H20.7337V14.9854H29.7025V11.0908H15.7538V28.909H30.0328Z",
    fill: "#1641A1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -4.26484,
    cy: 3.36353,
    rx: 26.95,
    ry: 27,
    fill: "url(#paint0_linear)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.0041,
    cy: 26.9092,
    rx: 1.9963,
    ry: 2,
    fill: "#34995C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7009 11.0908H38.291V28.909H46.7009C48.6488 28.909 50.3765 28.5442 51.884 27.8145C53.3915 27.0848 54.5602 26.0496 55.3902 24.709C56.2202 23.3684 56.6352 21.7987 56.6352 19.9999C56.6352 18.2011 56.2202 16.6314 55.3902 15.2908C54.5602 13.9502 53.3915 12.9151 51.884 12.1854C50.3765 11.4557 48.6488 11.0908 46.7009 11.0908ZM50.1563 23.589C49.2416 24.4545 48.0221 24.8872 46.4976 24.8872H43.3217V15.1126H46.4976C48.0221 15.1126 49.2416 15.5454 50.1563 16.4108C51.0879 17.2763 51.5537 18.4726 51.5537 19.9999C51.5537 21.5272 51.0879 22.7235 50.1563 23.589Z",
    fill: "#353333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5609 28.909V25.0145H64.2618V21.7563H72.1635V17.989H64.2618V14.9854H73.2306V11.0908H59.2819V28.909H73.5609Z",
    fill: "#353333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6315 28.909V25.0145H81.3324V21.7563H89.2341V17.989H81.3324V14.9854H90.3012V11.0908H76.3525V28.909H90.6315Z",
    fill: "#353333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -4.1741,
    y1: 3.45443,
    x2: -4.26518,
    y2: 30.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B86E"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSimple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_simple.652364ffaa73fe7f903bb1e8394abc9f.svg";